module.exports = __webpack_public_path__ + "static/img/0353f98797a46e27aa3af0755a37bb29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon1.png
// module id = Ymhj
// module chunks = 1